module.exports = {"title1":"Privacy Policy"}


//////////////////
// WEBPACK FOOTER
// ./src/data/privacy-policy.json
// module id = 325
// module chunks = 15400075347947